export enum Catalogs {
  GET_ACT_COM = '/businessActivities',
  GET_FUND_SOURCE = '/fundSources',
  GET_CURRENCY_LIST = '/currencies',
  GET_COUNTRIES = '/countries',
  GET_OCUPATIONS = '/occupations',
  GET_TYPE_ID = '/identificationTypes?system=DAE',
  GET_BUSSINESS_ENTITY_TYPE = '/businessEntityTypes',
}
